/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/no-did-mount-set-state */
import React, { type Node } from 'react';
import { get } from 'lodash';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import { Input, Button } from 'angieslist-react-components';
import { tracker } from 'angieslist-app-platform';
import './Options.scss';
import { DEFAULT_OFFSET, PROS_PER_PAGE } from '../../common/BusinessListConstants';
import businessListActions from '../../../../../../../app/common/businessList/businessListActions';

type OptionProps = {
  closeFilter?: any,
  // Redux state
  serviceProviders: any,
  setSortBy: (sortBy: string) => void,
  sortByValue: string,
  // Redux actions
  getServiceProviders: typeof businessListActions.getServiceProviders
};


export class Options extends React.Component<OptionProps> {
  constructor(props: OptionProps) {
    super(props);
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }

  componentDidMount() {
    const { serviceProviders } = this.props;
    const sortedBy = get(serviceProviders, 'response.sortedBy', 'name');

    this.props.setSortBy(sortedBy);
  }

  handleRadioChange: any | (() =>
    Promise<void | any>) = (e: any) => {
      this.props.setSortBy(e.currentTarget.value);
    }

  handleFilter: any | (() =>
    Promise<void | any>) = (e: any) => {
      this.sendFilterAndSortEventsToSegment();
      const {
        getServiceProviders, serviceProviders, closeFilter, sortByValue,
      } = this.props;
      if (closeFilter) closeFilter();
      const sortedBy = get(serviceProviders, 'response.sortedBy', 'name');

      if (sortByValue !== sortedBy) {
        getServiceProviders({
          sortBy: sortByValue,
          // start back at the new beginning of result set if a sort or filter is applied
          offset: DEFAULT_OFFSET,
          limit: PROS_PER_PAGE,
        });
      }
    }


  sendToTracker = (description) => {
    tracker.track('Item Clicked', {
      ...{
        activityLocation: 'SP : Business List',
        description,
      },
    });
  }

  sendSortByEvent = (sortByValue) => {
    switch (sortByValue) {
      case 'ratings':
        this.sendToTracker('Clicks on customer rating sort by');
        break;

      case 'reviews':
        this.sendToTracker('Clicks on total reviews sort by');
        break;

      default:
        this.sendToTracker('Clicks on business name sort by');
        break;
    }
  }


  sendFilterAndSortEventsToSegment() {
    const { sortByValue } = this.props;
    this.sendSortByEvent(sortByValue);
  }

  props: OptionProps;

  render(): Node {
    return (
      <div className="businesslist-options">
        <div className="filter-options">
          <strong> Sort by </strong>
          <Input id="filterOptionsSortByName" value="name" type="radio" role="radio" label="Business name (A-Z)" name="filterOptionsSortBy" onClick={e => this.handleRadioChange(e)} defaultChecked checked={this.props.sortByValue === 'name'} />
          <Input id="filterOptionsSortByRating" value="ratings" type="radio" role="radio" label="Customer rating (high to low)" name="filterOptionsSortBy" onClick={e => this.handleRadioChange(e)} checked={this.props.sortByValue === 'ratings'} />
          <Input id="filterOptionsSortByReview" value="reviews" type="radio" role="radio" label="Total reviews (high to low)" name="filterOptionsSortBy" onClick={e => this.handleRadioChange(e)} checked={this.props.sortByValue === 'reviews'} />
          <div className="filter-options-apply text-center">
            <Button
              id="filter-options-apply-button"
              className="apply-button"
              onClick={() => this.handleFilter()}
              bsSize="small"
              bsStyle="default-office"
              flat
            >
              APPLY
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default (hot(module)(compose(
  connect(
    state => ({
      serviceProviders: state.businessList.getServiceProviders,
    }),
    {
      ...businessListActions,
    },
  ),
  pure,
)(Options)): any);



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/BusinessList/components/Options.js